import pointCloudLinks from './pointCloudLinks';

export default pointCloudLinks;
